import { BaseApiV2, Methods } from "@newview/infrastructure";

export abstract class BasicsBaseApiV2 extends BaseApiV2 {
    public get ProxyName(): any {
        return 'NvBasicsV2Api';
    }
}
